<template>
    <option value="agrology-numpy-pandas-aws">Numpy/Pandas</option>
    <option value="agrology-numpy-pandas-geospatial-aws">Numpy/Pandas+Geospatial</option>
    <option value="agrology-tensorflow-aws">Tensorflow</option>
</template>
